var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products_page pg_0"},_vm._l((_vm.units),function(unit){return _c('Unit',{key:unit.code,attrs:{"unit":unit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }